import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiExperiments {
  static getExperimentModel(pathId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/new`);
  }

  static createExperiment(pathId, experiment) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments`, {
      method: "POST",
      body: { experiment },
    });
  }

  static getExperiments(pathId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments`);
  }

  static setExperiment(pathId, expId, experiment) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${expId}`, {
      method: "PUT",
      body: { experiment },
    });
  }

  static startExperiment(pathId, expId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${expId}/start`, {
      method: "POST",
    });
  }

  static stopExperimentWithWinner(pathId, expId, variant) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${expId}/stop`, {
      method: "POST",
      body: { variation: { id: variant.id } },
    });
  }

  static stopExperiment(pathId, expId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${expId}/stop`, {
      method: "POST",
    });
  }

  static getExperiment(pathId, expId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${expId}`);
  }

  static getExperimentForceUpdate(pathId, expId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${expId}?force_update=true`);
  }

  static cloneExperiment(pathId, experimentId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${experimentId}/clone`, {
      method: "POST",
    });
  }

  static deleteExperiment(pathId, experimentId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/experiments/${experimentId}`, {
      method: "DELETE",
    });
  }
}
